import { createAction, handleActions } from 'redux-actions';
import { _getVenueList } from '~shared/httpService/apis';
import ActionTypes from '~shared/constants/actionTypes';

const initialState = {
  venue_list: {
    loading: false,
    response: [],
    hasError: false,
    error: {}
  },
};

export const getVenueListStart = createAction(ActionTypes.GET_VENUE_LIST);
export const getVenueListSuccess = createAction(ActionTypes.GET_VENUE_LIST_SUCCESS, response => response);
export const getVenueListError = createAction(ActionTypes.GET_VENUE_LIST_ERROR, error => error);

export const getVenueList = (page = '', pageSize, searchQuery) => (dispatch) => {
  dispatch(getVenueListStart());
  return _getVenueList(page, pageSize, searchQuery).then((response) => {
    dispatch(getVenueListSuccess(response));
  }).catch((error) => {
    dispatch(getVenueListError(error));
  });
};

const reducer = handleActions({
  //VENUE_LIST
  [ActionTypes.GET_VENUE_LIST]: (state) => ({
    ...state, venue_list: {
      ...state.venue_list,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_VENUE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    venue_list: {
      ...state.venue_list,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_VENUE_LIST_ERROR]: (state, action) => ({
    ...state,
    venue_list: {
      ...state.venue_list,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
}, initialState);
export default reducer;
